import axios from "axios";

export const state = {
    giveaways: [],
};

export const getters = {
    giveaways: state => state.giveaways,
};

export const mutations = {
    setGiveAways(state, newValue) {
        state.giveaways = newValue
    },
};

export const actions = {
    async fetchGiveAways({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/give-aways/${fyear}`).then(res => {
            commit('setGiveAways', res.data.giveaways)
        })
    },
};
